<template>
  <div id="mensaje" v-if="show">
    <div class="card">
      <div class="card-header">
        <div class="card-title"><strong>Atenci&#243;n</strong></div>
      </div>
      <div class="card-body">
        {{ mensaje }}
      </div>
      <div class="card-footer text-center">
        <button class="btn btn-primary btn-sm" @click="show=false">Aceptar</button>
      </div>
    </div>
  </div>
</template>

<script>
  import EventBus from '../EventBus';

  export default {
    data: () => ({
      show: false,
      mensaje: ''
    }),
    mounted() {
      //do something after mounting vue instance
      EventBus.$on("MOSTRAR_MENSAJE", (data) => {
        this.show = true;
        this.mensaje = data;
      });
    }
  }
</script>

<style lang="sass" scoped>
  #mensaje
    position: fixed
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)
    width: 450px
    z-index: 99999999
    -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.1)
    -moz-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.1)
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.1)

    .card-title
      margin: 0 !important
</style>



// WEBPACK FOOTER //
// src/components/Mensaje.vue